// import ENV from '../env'

export const getWebcamStream = async (constraints) => {
  console.log('constraints')
  console.log(constraints)
  let stream = null
  try {
    if (constraints.quality === 'low') {
      stream = await navigator.mediaDevices.getUserMedia({
        video: {
          width: { ideal: 500 },
          height: { ideal: 300 }
        }
      })
    } else if (constraints.quality === 'high') {
      stream = await navigator.mediaDevices.getUserMedia({
        video: {
          width: { ideal: 1280 },
          height: { ideal: 720 }
        }
      })
    }
    return {
      stream: stream,
      status: 'active'
    }
  } catch (err) {
    console.error('error getWebcamStream')
    console.error(err)
    console.error(err.name)

    if (err.name === 'NotAllowedError') {
      return {
        status: 'not_allowed',
        stream: null
      }
    } else if (err.name === 'NotFoundError') {
      return {
        status: 'not_available',
        stream: null
      }
    } else {
      return {
        status: 'unknown_error',
        stream: null
      }
    }
  }
}

export const getScreenRecorderStream = async () => {
  try {
    let stream = null
    let constraints = {
      video: true
      //  {
      //   frameRate: 15,
      //   // height: 600,
      //   // width: 800,
      //   resizeMode: 'crop-and-scale',
      //   cursor: 'always',
      //   displaySurface: 'monitor'
      //   // logicalSurface: true
      // }
    }

    if (navigator.mediaDevices.getDisplayMedia) {
      stream = await navigator.mediaDevices.getDisplayMedia(constraints)
    } else {
      stream = await navigator.getDisplayMedia(constraints)
    }

    return {
      status: 'active',
      stream: stream
    }
  } catch (err) {
    console.error('error getScreenRecorderStream')
    console.error(err)
    console.error(err.name)

    if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
      return {
        status: 'not_allowed',
        stream: null
      }
    } else {
      return {
        status: 'unknown_error',
        stream: null
      }
    }
  }
}

export const getVideoRecorder = (stream) => {
  let recorder = null
  let options = null

  if (typeof MediaRecorder.isTypeSupported == 'function') {
    if (MediaRecorder.isTypeSupported('video/webm;codecs=vp9')) {
      options = { mimeType: 'video/webm;codecs=vp9' }
    } else if (MediaRecorder.isTypeSupported('video/webm;codecs=h264')) {
      options = { mimeType: 'video/webm;codecs=h264' }
    } else if (MediaRecorder.isTypeSupported('video/webm;codecs=vp8')) {
      options = { mimeType: 'video/webm;codecs=vp8' }
    }
    recorder = new MediaRecorder(stream, options)
  } else {
    recorder = new MediaRecorder(stream)
  }

  return recorder
}

export const dataURItoBlob = (dataURI) => {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(dataURI.split(',')[1])

  // separate out the mime component
  var mimeString = dataURI
    .split(',')[0]
    .split(':')[1]
    .split(';')[0]

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length)

  // create a view into the buffer
  var ia = new Uint8Array(ab)

  // set the bytes of the buffer to the correct values
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }

  // write the ArrayBuffer to a blob, and you're done
  var blob = new Blob([ab], { type: mimeString })
  return blob
}

export const isMobileOrTablet = function() {
  var check = false
  ;(function(a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
        a.substr(0, 4)
      )
    )
      check = true
  })(navigator.userAgent || navigator.vendor || window.opera)
  return check
}

export const getAudioStream = async () => {
  let stream = null
  try {
    stream = await navigator.mediaDevices.getUserMedia({
      audio: true
    })

    return {
      stream: stream,
      status: 'active'
    }
  } catch (err) {
    console.error('error getAudio')
    console.error(err)
    console.error(err.name)

    if (err.name === 'NotAllowedError') {
      return {
        status: 'not_allowed',
        stream: null
      }
    } else if (err.name === 'NotFoundError') {
      return {
        status: 'not_available',
        stream: null
      }
    } else {
      return {
        status: 'unknown_error',
        stream: null
      }
    }
  }
}
